export default {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error'
};